"use client"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { type UnifiedMessage } from "@/lib/api"
import { useTranslation } from 'react-i18next';
import { formatCoMessageTime } from '@/app/utils/useFormat';
import dayjs from "dayjs";

/**
 * 主播关闭预约通知
 * messageType: 20
 * variables: { scheduleId, time, roomTitle, streamerId, streamerName, avatar }
 */
export function ScheduleCancelledItem({
    message: msg,
    children,
    isDropdown = false,
}: {
    message: UnifiedMessage,
    children?: React.ReactNode,
    isDropdown?: boolean,
}) {
    const { t } = useTranslation();
    const { variables, createTime } = msg;
    const showTimeWithChildren = Boolean(isDropdown && children);
    const liveTime = dayjs(variables.time);
    const isToday = liveTime.isSame(dayjs(), 'day');
    const scheduledTimeLabel = isToday
        ? `${t('time.today')} ${liveTime.format('HH:mm')}`
        : `${liveTime.format('MM-DD')} ${liveTime.format('HH:mm')}`;

    return (
        <>
            <Avatar
                className="w-10 h-10 flex-shrink-0 cursor-pointer"
                onClick={(e) => {
                    e.stopPropagation();
                    const streamerHandle = (variables as any).streamerHandle ?? (variables as any).handle;
                    if (streamerHandle) {
                        window.open(`/${streamerHandle}`, '_blank');
                    }
                }}
            >
                <AvatarImage src={variables.avatar} />
                <AvatarFallback className="text-xs">{variables.streamerName?.[0]}</AvatarFallback>
            </Avatar>

            <div className="flex-col flex gap-1 flex-1 min-w-0">
                {showTimeWithChildren ? (
                    <div className="flex items-center justify-between gap-2 mb-1">
                        <div className="min-w-0 flex items-center gap-2 flex-wrap">{children}</div>
                        <span className="text-xs text-font-primary/50 flex-shrink-0 whitespace-nowrap">
                            {formatCoMessageTime(createTime)}
                        </span>
                    </div>
                ) : null}
                <div className="flex items-center justify-between gap-2">
                    <p className="text-sm text-font-primary font-semibold line-clamp-2 break-words flex items-start gap-1 min-w-0">
                        {!isDropdown && children}
                        {t('explore.liveStreamCancelledTitle')}
                    </p>
                    {!showTimeWithChildren && (
                        <span className="text-xs text-font-primary/50 flex-shrink-0 whitespace-nowrap">
                            {formatCoMessageTime(createTime)}
                        </span>
                    )}
                </div>

                <p className="text-xs text-font-primary/70 line-clamp-2 break-all">
                    {t('explore.liveStreamCancelledDesc', {
                        streamerName: variables.streamerName,
                        time: scheduledTimeLabel,
                    })}
                </p>
            </div>
        </>
    )
}
